export const unnecessaryModals = [
  'ticketGetModal',
  'aboutBonuses',
  'drawResultModal',
  'drawingRules',
  'ultraTotalDrawingModal',
  'totalDrawingModal',
  'halloweenEvent',
  'nextPlan',
  'getBonuses',
  'tutorialEvent',
  'technicalWorks',
  'charmBurning',
  'couponOctoberModal',
  'cyberOctoberModal',
  'octoberEvent',
  'movingOctoberModal',
  'octoberModal',
  'bathroomPackageInfo',
  'blackfriday',
  'mainPackageInfo',
  'cyberBuy',
  'endVacElf',
  'nYWinners',
  'nYWinWeek',
  'wishCard',
  'userPlayedInGames',
]

export const unnecessaryFields = ['errors', 'isDarkTheme']
